export enum ConnectedAccountCurrencyConversionStatus {
    Pending = 'pending',
    Overdue = 'overdue',
    Settled = 'settled',
    Cancelled = 'cancelled',
    Blocked = 'blocked',
    InProgress = 'in-progress',
}
